import React from 'react';

import { routes } from '@aline/routes';
import { Helmet } from 'react-helmet';
import { Route, Routes } from 'react-router-dom';
import { ContentWrapper } from 'src/components';
import { createRelativeRouter } from 'src/helpers/router-helpers';
import { makeStyles } from 'tss-react/mui';

import { PlaybookDetailPage } from './detail';
import { PlaybooksTab } from './PlaybooksTab';

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: 0,
    minWidth: 0,
  },
});

const { toRelativePath: toRelativePlaybooksPath } = createRelativeRouter(routes.PlaybooksIndex, {
  nestedRoutes: true,
});

export function Playbooks(): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Helmet>
        <title>Playbooks</title>
      </Helmet>
      <Routes>
        <Route
          element={
            <ContentWrapper>
              <PlaybooksTab />
            </ContentWrapper>
          }
          path={toRelativePlaybooksPath(routes.PlaybooksIndex)}
        />
        <Route
          element={<PlaybookDetailPage />}
          path={toRelativePlaybooksPath(routes.PlaybooksDetailRule)}
        />
        <Route
          element={<PlaybookDetailPage />}
          path={toRelativePlaybooksPath(routes.PlaybooksDetail)}
        />
      </Routes>
    </div>
  );
}
